export default "__VITE_ASSET__4c814668__"